import { createContext, useContext } from 'react';
import { type OrderTypeToSoundMapType, INITIAL_SOUND_CONFIG } from './SoundProviderUtils';

interface SoundSettingsContextProps {
  enableSoundEffects: boolean;
  enabledSounds: {
    [K in OrderTypeToSoundMapType]: boolean;
  };
  setEnableSoundEffects: (newValue: boolean) => void;
  setEnabledSounds: (newValue: {
    [K in OrderTypeToSoundMapType]: boolean;
  }) => void;
}

export const DefaultSoundSettingsConfig: SoundSettingsContextProps = {
  enableSoundEffects: false,
  enabledSounds: INITIAL_SOUND_CONFIG,
  setEnableSoundEffects: () => {},
  setEnabledSounds: () => {},
};

export const SoundSettingsContext = createContext<SoundSettingsContextProps>(DefaultSoundSettingsConfig);
SoundSettingsContext.displayName = 'SoundSettingsContext';
export const useSoundSettings = () => {
  const context = useContext(SoundSettingsContext);
  if (context == null) {
    throw new Error('Missing SoundSettingsContext.Provider further up in the tree. Did you forget to add it?');
  }
  return context;
};
